import Vue from "vue";

/**
 * @see https://www.digitalocean.com/community/tutorials/vuejs-global-event-bus
 */
export const EventBus = new Vue();
